export const BaseColors = {
    // inputs
    strokePrimary: '#CACFE7',
    strokeContrast: '#232629',

    // text
    textPrimary: '#232629',
}